export class Currency {
  symbol: string;
  code: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}
